export class Token {
    isFullAccessUser: boolean
    isLimitedAccessUser: boolean;
    isReadOnlyUser: boolean;
}
